<template>
  <div class="tw:relative tw:flex tw:items-center tw:w-full">
    <div
      class="tw:flex tw:items-center tw:border tw:border-gray-500 tw:px-6 box-size-44 tw:text-base tw:rounded-lg tw:mr-2 tw:font-base tw:w-full"
      :class="disabled ? 'tw:bg-gray-100' : 'tw:bg-white'"
    >
      <input
        type="text"
        id="property_search"
        class="tw:focus:outline-hidden tw:grow tw:w-full"
        :class="{ 'tw:bg-gray-100': disabled }"
        :placeholder="'Type the accommodation id, organisation id, or organisation name'"
        :disabled="disabled"
        :value="searchValue"
        @input="updateSearchValue"
        @keypress.enter="search"
      />
      <Search class="tw:size-[17px]" />
    </div>
    <MainButton @click="search">{{ 'Search' }}</MainButton>
  </div>
</template>

<script setup>
import Search from '@/components/icons/Search.svg?component'
import MainButton from '@/components/base/buttons/MainButton.vue'

defineProps({
  searchValue: String,
  disabled: Boolean,
})
const emit = defineEmits(['updateSearchValue', 'search'])
const updateSearchValue = e => emit('updateSearchValue', e.target.value)
const search = () => emit('search')
</script>
